export type PluginDataSourceHandler = (
  url: string
) => Promise<{ status: number; data: any; error?: any }>;

const registry = new Map<string, PluginDataSourceHandler>();

export const registerPluginDataSource = (
  id: string,
  handler: PluginDataSourceHandler
) => registry.set(id, handler);

export const resolvePluginDataSource = (url?: string | null) => {
  if (!url?.startsWith('pipesv2://')) return undefined;
  try {
    return registry.get(new URL(url).host);
  } catch {
    return undefined;
  }
};
